import 'jquery-sticky';
import './less/topMenu.less';

import { getWindowWidth } from '../../js/core/Helpers/Helpers';
import menuList from '../menuList/menuList';

const TopMenu = function(isSticky){
    let hasSubmenu = $('.hasSubmenu');
    let topMenu = document.querySelector('#topMenu');
    let sideMenu = document.querySelector('#sideMenu');
    let submenu = '.topMenu__submenu';
    let contactOpener = $('.JS_contactOpener');
    let canvasElements = document.getElementsByClassName('canvasElement');
    let menuOpener = $('.JS_menuOpener');
    let _this = this;
    
    this.toggleElements = () => {
        if(topMenu) {
	        if($(document).scrollTop() > 100) {
		        topMenu.classList.add('slided');
	        } else {
		        topMenu.classList.remove('slided');
		        if (getWindowWidth() > 1024){
			        sideMenu.dispatchEvent( new Event('closeOffcanvasSidebar'));
		        }
	        }
        }
    };
    
    this.init = () => {
        isSticky ? this.enableStickyMenu() : null;
    
        menuOpener.click(function(){
            contactOpener.removeClass('active');
            $('.JS_mobileContact').removeClass('active');
            $(this).hasClass('active') ?  $(this).removeClass('active') : $(this).addClass('active');
            $('.JS_topMenu').toggleClass('active');
        });
    
        contactOpener.click(function(){
            menuOpener.removeClass('active');
            $('.JS_topMenu').removeClass('active');
            
            $(this).hasClass('active') ?  $(this).removeClass('active') :  $(this).addClass('active');
            $('.JS_mobileContact').toggleClass('active');
        });
        
    
        window.addEventListener("scroll", function(){
            _this.toggleElements();
        });
        
    };
    
    this.enableStickyMenu = () => {
       /* if (w > 991) {
            $("#topMenu").sticky({topSpacing: 0});
        }*/
    };
    
    
    $('.JS_submenu-opener').click(function(){
        $(this).toggleClass('active').prev('ul').toggleClass('active');
    });
    
    

    
    
    
    this.init();
};


const topMenu = new TopMenu(true);

export { topMenu };


// WEBPACK FOOTER //
// ./components/topMenu/topMenu.js